import { narrativeStatus } from '@helpers';

import clamp from 'lodash/clamp';

/**
 * gets Narrative status message to display
 * @param  {Object}  options.data
 * @param  {boolean} options.showTruncatedMessage
 * @return {string}
 */
export const getNarrativeStatusMessage = ({ data, showTruncatedMessage }) => {
  const processingStatuses = [narrativeStatus.RUNNING, narrativeStatus.CLEANUP];
  const topicCount = data?.numberCompleteTopics + data?.numberIncompleteTopics;

  let message;

  switch (true) {
    case data?.status === narrativeStatus.QUEUED:
      message = 'In Queue';
      break;
    case data?.status === narrativeStatus.SETUP:
      message = 'Setup';
      break;
    case processingStatuses.includes(data?.status):
      message =
        (showTruncatedMessage ? '' : 'Processing ') +
        `(${clamp(data?.numberCompleteTopics + 1, 1, topicCount)}/${topicCount})`;
      break;
    case data?.status === narrativeStatus.COMPLETED:
      return 'Complete';
    case data?.status === narrativeStatus.EXCEPTION:
      return 'Failed';
    case data?.status === narrativeStatus.CANCELLED:
      return 'Canceled';
    case data?.status === narrativeStatus.INVALIDATED:
      return 'Invalidated';
    default:
      message = '';
  }

  return message;
};
